import { useEffect, useState } from 'react';
import {
  Lender,
  SupplierCode,
  SupplierName,
  useLendersApi,
} from '@equifinance/shared';

export type Lenders = {
    secured:Lender[],
    unsecured:Lender[],
}

export type LenderRecord = Record<SupplierCode, SupplierName>;

export const useLenders = () => {
  const [lenders, setLenders] = useState<Lenders>({ secured: [], unsecured: [] });
  const { getLenders } = useLendersApi();

  useEffect(() => {
    const fetchLenders = async () => {
      setLenders({
        secured: await getLenders('secured'),
        unsecured: await getLenders('unsecured'),
      });
    };

    fetchLenders();
  }, []);

  return lenders;
};

export const useLenderOptions = (type: 'secured' | 'unsecured') => {
  const lenders = useLenders();
  return lenders[type].reduce((prev, { supplierCode, name }) => ({
    ...prev,
    [supplierCode]: name,
  }), {} as LenderRecord);
};
